import { render } from "./TextMessage.vue?vue&type=template&id=3c8e517c&scoped=true"
import script from "./TextMessage.vue?vue&type=script&lang=js"
export * from "./TextMessage.vue?vue&type=script&lang=js"

import "./TextMessage.vue?vue&type=style&index=0&id=3c8e517c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8e517c"]])

export default __exports__